import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface SearchFormProps {
  onSearch: (query: string) => void;
  isLoading?: boolean;
  initialQuery?: string;
}

export function SearchForm({ onSearch, isLoading = false, initialQuery = '' }: SearchFormProps) {
  const [query, setQuery] = useState(initialQuery);

  // Обновляем query при изменении initialQuery
  useEffect(() => {
    setQuery(initialQuery);
  }, [initialQuery]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      onSearch(query.trim());
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Поисковый запрос</CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Input
              id="search-query"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Иванов Иван Иванович, +7 999 123-45-67, example@email.com..."
              disabled={isLoading}
            />
          </div>
          <Button 
            type="submit" 
            className="w-full" 
            disabled={!query.trim() || isLoading}
          >
            {isLoading ? 'Поиск...' : 'Найти'}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
}
